<template>
  <div class="page-content">
    <el-row class="sign-manage-title">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-search" style="color: #4882ff;font-size: 18px;font-weight: bold;margin-left: 10px"></i>
        <span class="order-list-search-span" style="margin-left: 6px">自定义菜单</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
      </el-col>
    </el-row>
    <el-row class="box-content">
      <div class="box-content-div">
        <el-form :model="formInline" label-width="100px"  class="box-content-form">
          <el-form-item label="客服账号:" style='position:relative;margin-bottom: 50px;'>
            <el-input v-model="formInline.officeName" placeholder=""></el-input>
            <p style="margin: 0;line-height: 25px;text-align: left;position: absolute;width: 155%;bottom: -39px;">不能重复，保存不能修改，由字母、数字组成</p>
          </el-form-item>
          <el-form-item label="客服昵称:">
            <el-input v-model="formInline.officeName" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="登录密码:">
            <el-input v-model="formInline.officeName" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="" style="text-align: left;">
            <el-button type="primary">保存</el-button>
            <el-button @click='goBack'>返回</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-row>
  </div>
</template>

<script>
// import {  } from '@/api/customer.js'
export default {
  name: 'publicNumber',
  data () {
    return {
      formInline: {}
    }
  },
  mounted () {
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    }
  },
  created() {
  }
}
</script>

<style scoped>
.sign-manage-title {
  background: #ecf6ff;
  border: 1px solid #E4e4e4;
  height:60px;
  padding:10px;
  line-height: 40px;
  margin-top: 10px;
}
.green{
  color: green;
}
.red{
  color: red;
}
.add-btn{
  height: 30px;
  padding: 0 10px;
  border-radius: 20px;
  text-align: center;
  line-height: 30px;
  float: right;
  color: #fff;
  font-size: 14px;
  background: #4882ff;
  margin-top: 5px;
  cursor: pointer;
}
.table-title {
  text-align: left;
}
.dialog-content {
  height: 200px;
}
.content-one span {
  display: inline-block;
  float: left;
  line-height: 20px;
  font-size: 16px;
  margin-top: 10px;
}
.content-one p {
  text-align: left;
}
.box-content-div {
  width: 600px;
  margin: auto;
}
.box-content-form {
  margin-top: 10px;
  text-align: center;
}
.box-content-form .el-form-item {
  width: 300px;
}
</style>
